var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSyncrunning = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 28,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#008060",
  d: "M14.097 4.375c2.127 0 4.142.695 5.807 1.96L16.05 9.964l9.804 1.051-.461-9.849-3.91 3.682a11.67 11.67 0 0 0-7.386-2.612C7.611 2.236 2.333 7.514 2.333 14h2.14c0-5.308 4.317-9.625 9.624-9.625M14.097 23.625a9.55 9.55 0 0 1-5.807-1.96l3.854-3.629-9.804-1.051.461 9.848 3.91-3.68a11.67 11.67 0 0 0 7.386 2.61c6.486 0 11.764-5.277 11.764-11.763h-2.14c0 5.308-4.317 9.625-9.624 9.625"
})));
export { SvgSyncrunning as ReactComponent };
export default __webpack_public_path__ + "static/media/sync.running.4c3e3436.svg";